import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { isVideo, getPreviewForFileInput, convertUrlToFileSingle } from 'services/utilsService';
import ThumbnailButton from './ThumbnailButton/ThumbnailButton';
import DropzoneRender from './DropzoneRender';

import './FilesComponent.scss';

const FileComponent = ({ input, id, accept, disabled, dropzoneProps }) => {
  let name = '';
  let size = 0;
  let typeVideo = false;

  // preview is set as a local variable because it is too large
  // and so that it is not sent to the backend
  const [preview, setPreview] = useState('');
  const hasValue = input.value && input.value.length === 1;
  const isString = hasValue && input.value[0].url;

  useEffect(() => {
    if (input?.value?.[0]) {
      setPreview(URL.createObjectURL(input.value[0]));
    }
  }, [input?.value?.[0]]);

  const removeFromValues = () => {
    input.onChange([]);
  };

  const onDropFunc = (newFiles) => {
    Promise.resolve(getPreviewForFileInput(setPreview, newFiles)).then((file) => {
      input.onChange([file]);
    });
  };

  // this is done when a url is passed down as an initial input value
  if (hasValue && isString) {
    Promise.resolve(convertUrlToFileSingle(input.value[0])).then((res) => {
      input.onChange([res.file]);
      setPreview(res.preview);
    });
  }

  if (hasValue && !isString) {
    ({ name, size } = input.value[0]); // eslint-disable-line
    typeVideo = isVideo(input.value[0]);
  }

  return (
    <div
      className={`
        files-component-wrapper file-wrapper ${hasValue ? 'has-file' : 'no-file'} ${disabled && 'disabled'}
      `}
    >
      {!hasValue && (
        <DropzoneRender
          input={input}
          id={id}
          onDropFunc={onDropFunc}
          disabled={disabled}
          accept={accept}
          {...dropzoneProps}
        />
      )}
      {hasValue && (
        <div className="new-files-list">
          <div className="new-file">
            <div className="media-wrapper">
              {typeVideo && <video src={preview} muted />}
              {!typeVideo && <img src={preview} alt="file-preview" />}
            </div>

            <ThumbnailButton
              name={name}
              submitText="Remove"
              submittingText="Removing"
              iconClass="cross"
              submitting={false}
              handleClick={(e) => removeFromValues(e, name, size)}
            />
          </div>
        </div>
      )}
    </div>
  );
};

FileComponent.defaultProps = {
  id: '',
  disabled: false,
  accept: '',
  dropzoneProps: {},
};

FileComponent.propTypes = {
  dropzoneProps: PropTypes.object,
  input: PropTypes.object.isRequired,
  id: PropTypes.string,
  disabled: PropTypes.bool,
  accept: PropTypes.string,
};

export default FileComponent;
